import React from 'react';

interface PlayerProps {
	isOpen: boolean;
	url: string;
	type: 'video' | 'audio';
	name: string
}

const Player: React.FC<PlayerProps> = ({
	isOpen, url, name, type,
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<div className="col-span-3 relative w-full mt-[13px]">
			<p className="text-[12px] pb-[5px] pl-[2px] text-gray-800">{name}</p>
			<div className="player-wrapper w-full">
				<video
					src={url}
					style={{
						display:   'block',
						width:     '100%',
						height:    type === 'video' ? '100%' : '56px',
						maxHeight: '222px',
					}}
					controls
					autoPlay
				/>
			</div>
		</div>
	);
};

export default Player;
